module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// /exlibris/product/npm_modules/release-URM/prima/node_modules/lodash/extend.js
// module id = 354
// module chunks = 6